import {
	SimpleForm,
	ReferenceInput,
	SelectInput,
	TextInput,
	ImageInput,
	ImageField,
	LongTextInput,
	DateInput,
	DateField
} from "react-admin";
import React from "react";
import { required } from "../../services/validate";
import { SUPERADMIN } from "../../constant/TypeRole";
import { typeFacilityBooking } from "../../constant/TypeFacilityBooking";

const FacilityBookingForm = props => {
	const { record } = props;
	const { permissions } = props;
	const project = JSON.parse(localStorage.getItem("project"));
	const filter = permissions
		? permissions === SUPERADMIN
			? {}
			: { project }
		: {};
	return (
		<SimpleForm {...props}>
			<ReferenceInput disabled={true} validate={[required()]}
				source="facility"
				reference="facilities">
				<SelectInput optionText="name" />
			</ReferenceInput>

			<ReferenceInput disabled={true} validate={[required()]}
				source="user"
				reference="user">
				<SelectInput optionText="email" />
			</ReferenceInput>

			<ReferenceInput disabled={true} validate={[required()]}
				source="room"
				reference="room">
				<SelectInput optionText="name" />
			</ReferenceInput>

			<ReferenceInput disabled={true} validate={[required()]}
				source="project"
				reference="project" perPage={1000}
				filter={filter}
			>
				<SelectInput optionText="name" />
			</ReferenceInput>
			<DateField source="booking_date" showTime locales="th-TH"
				options={{
					day: "numeric",
					month: "short",
					year: "numeric",
					hour: "numeric",
					minute: "numeric"
				}} />
			<LongTextInput disabled={true} source="description" />
			<SelectInput
				source="status"
				label="สถานะ"
				choices={typeFacilityBooking}
			/>
		</SimpleForm>
	);
};

export default FacilityBookingForm;



// WEBPACK FOOTER //
// ./src/components/facilitybooking/FacilityBookingForm.js